import { dto_selected_merchant_or_product } from "../../../../classes/dto-selected-merchant-or-product";
import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { FORMAT_DECIMAL_VALUE } from "../../../../functions/funtion";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { Colors } from "../../../../util/colors";
import { CSP } from "../../../../config/config";
import QtyPlusViewOnProductListView from "../pg-product-list-qty/product-list-item-wise-qty";
import React from "react";

export default class ItemView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showQuickAdd: false,
    };
    this.lastTouchTs = 0;
    this.touchMoved = false;
    this.touchStart = null;
  }

  componentDidMount() {
    if (
      dto_selected_merchant_or_product.IO &&
      this.props.IsAvailable &&
      !this.props.data.W
    ) {
      this.setState({ showQuickAdd: true });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.showQuickAdd !== this.state.showQuickAdd) {
      return true;
    }

    return (
      nextProps.data !== this.props.data ||
      nextProps.pid !== this.props.pid ||
      nextProps.index !== this.props.index ||
      nextProps.IsAvailable !== this.props.IsAvailable ||
      nextProps.Description !== this.props.Description ||
      nextProps.GenDesc !== this.props.GenDesc ||
      nextProps.UD !== this.props.UD ||
      nextProps.SP !== this.props.SP ||
      nextProps.ThemeColor !== this.props.ThemeColor ||
      nextProps.ProductImage !== this.props.ProductImage
    );
  }

  handleTouchStart = (event) => {
    if (!event.touches || !event.touches[0]) {
      return;
    }
    this.touchMoved = false;
    this.touchStart = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
    };
  };

  handleTouchMove = (event) => {
    if (!this.touchStart || !event.touches || !event.touches[0]) {
      return;
    }
    const dx = event.touches[0].clientX - this.touchStart.x;
    const dy = event.touches[0].clientY - this.touchStart.y;
    if (Math.hypot(dx, dy) > 8) {
      this.touchMoved = true;
    }
  };

  handleTouchEnd = (event) => {
    const isQtyControl = (target) => {
      if (!target || !target.closest) {
        return false;
      }
      return target.closest("#qty");
    };
    this.touchStart = null;
    if (this.touchMoved) {
      return;
    }
    if (isQtyControl(event.target)) {
      return;
    }
    this.lastTouchTs = Date.now();
    event.preventDefault();
    this.props.onClick(this.props.pid, this.props.index);
  };

  handleItemClick = () => {
    if (Date.now() - this.lastTouchTs < 500) {
      return;
    }
    this.props.onClick(this.props.pid, this.props.index);
  };

  render() {
    return (
      <div
        className="features"
        key={this.props.pid + "KEY"}
        id={this.props.pid + "PRD" + this.props.index}
        style={{
          marginTop: CSP === "MK" || CSP === "DT" ? 0 : 15,
          marginBottom: CSP === "MK" || CSP === "DT" ? 2 : 10,
          flexDirection: "row",
          justifyContent: "space-between",
          cursor: "pointer",
          padding: 5,
          backgroundColor: "white",
        }}
        onClick={this.handleItemClick}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
      >
        <div
          className="fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
        >
          <div style={{ display: "flex", textAlign: "left" }}>
            <div style={{ width: "100%", paddingRight: "10px" }}>
              <p
                style={{
                  margin: 0,
                  fontSize: CSP === "MK" || CSP === "DT" ? "15px" : "18px",
                  fontFamily: F_Fammily.Medium,
                }}
              >
                {this.props.Description}
              </p>
              {this.props.GenDesc !== "" ? (
                <p
                  style={{
                    marginTop: "1px",
                    marginBottom: "1px",
                    fontSize: Font.Amount,
                    fontStyle: "italic",
                  }}
                >
                  {this.props.GenDesc}
                </p>
              ) : null}
              {this.props.UD > 0 ? (
                <div style={{ display: "flex" }}>
                  <p
                    style={{
                      paddingTop: 0,
                      marginTop: "5px",
                      marginBottom: "1px",
                      fontSize: "15px",
                      color: "red",
                      alignSelf: "stretch",
                      textDecorationLine: "line-through",
                      textDecorationStyle: "solid",
                      marginRight: 5,
                    }}
                  >
                    {dto_StartupPageLoadInfo.Currency}
                    {"  "}
                    {FORMAT_DECIMAL_VALUE(2, this.props.SP, 2)}
                  </p>
                  <p
                    style={{
                      paddingTop: 0,
                      color:
                        CSP === "MK" || CSP === "DT"
                          ? "black"
                          : this.props.ThemeColor,
                      marginTop: "5px",
                      marginBottom: "1px",
                      fontSize: "15px",
                    }}
                  >
                    {dto_StartupPageLoadInfo.Currency}
                    {"  "}
                    {FORMAT_DECIMAL_VALUE(
                      2,
                      parseFloat(this.props.SP) - parseFloat(this.props.UD),
                      2
                    )}
                  </p>
                </div>
              ) : (
                <p
                  style={{
                    paddingTop: 0,
                    color:
                      CSP === "MK" || CSP === "DT"
                        ? "black"
                        : Colors.ThemeBGcolor,
                    marginTop: "5px",
                    marginBottom: "5px",
                    fontFamily: "Medium",
                    fontSize: CSP === "MK" || CSP === "DT" ? "13px" : "15px",
                    fontWeight: CSP === "MK" || CSP === "DT" ? "bold" : "",
                  }}
                >
                  {dto_StartupPageLoadInfo.Currency}
                  {"  "}
                  {FORMAT_DECIMAL_VALUE(2, parseFloat(this.props.SP), 2)}
                </p>
              )}

              {this.props.IsAvailable ? (
                <p
                  style={{
                    marginTop: "1px",
                    fontSize: Font.SmallDescription,
                    color: "green",
                  }}
                >
                  Available
                </p>
              ) : (
                <p
                  style={{
                    marginTop: "1px",
                    fontSize: "15px",
                    color: "red",
                  }}
                >
                  Not Available
                </p>
              )}
            </div>
            <div style={{ position: "relative" }}>
              {this.props.ProductImage}
              {this.state.showQuickAdd && (
                <QtyPlusViewOnProductListView
                  item={this.props.data}
                  onCartUpdated={this.props.onCartUpdated}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
